import EquipmentPage from "@/components/site-settings/EquipmentPage";
import { createFileRoute } from "@tanstack/react-router";

export interface EquipmentSearchParams {
  nodeId?: string;
  lineId?: string;
}

export const Route = createFileRoute("/_authenticated/site-settings/equipment")(
  {
    validateSearch: (
      search: Record<string, unknown>,
    ): EquipmentSearchParams => ({
      nodeId: (search.nodeId as string) || undefined,
      lineId: (search.lineId as string) || undefined,
    }),
    component: EquipmentPage,
  },
);
